import React, { Suspense, useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { Button, Table, Modal } from "react-bootstrap";
import { GetAllDevelopmentImages, deleteDevelopmentImages, saveDevelopmentImages, updateDevelopmentImages } from '../../../../services/CommonService';
import FileBase64 from 'react-file-base64';

function AddDevelopmentImages({ topicprops }) {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const fields = {
        image: '',
        status: '',
        position: '',
        developmentid: topicprops.id
    }
    const errors = {
        name: '',
        status: '',
        position: '',
    }
    const [subadminbar, setSubAdminbar] = useState(true);
    const [filefields, setFileFields] = useState(null);
    const [imageshow, setImageshow] = useState(null);


    useEffect(() => {
        getAllTopic()
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        // console.log("constuserdetails",constuserdetails.roles[0]);
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN') {
            setSubAdminbar(false)
        }

    }, [])
    const [formfields, setFromFields] = useState(fields);
    const [errorFields, setErrorFields] = useState(errors);
    const [topic, setTopic] = useState([]);
    const [postModal, setPostModal] = useState(false);
    const [subTopicData, setSubTopicData] = useState({})

    const { name, status, position } = formfields

    const getAllTopic = async () => {
        const reqdata = {
            pageno: '-1',
            query: { developmentid: topicprops.id }
        }
        const ResponseData = await GetAllDevelopmentImages(reqdata)
        console.log("get resp", ResponseData.data)
        setTopic(ResponseData.data)

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["position"]) {
            formIsValid = false;
            errors["position"] = "*Please enter display position name .";
        }

        // if (!fields["name"]) {
        //     formIsValid = false;
        //     errors["name"] = "*Please enter Topic name .";
        // }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }

        setErrorFields(errors)
        return formIsValid;

    }
    const submitForm = async () => {
        console.log("formfields", formfields);
        const isValid = await validateForm();
        if (isValid) {
            formfields.image = filefields;
            if (!formfields.id) {
                //save
                const Response = await saveDevelopmentImages(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    getAllTopic()
                    setFromFields(fields);
                    setFileFields()
                    setImageshow(false)
                }

            } else {
                //update
                const Response = await updateDevelopmentImages(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    getAllTopic()
                    setFromFields(fields)
                    setFileFields()
                    setImageshow(false)
                }
            }
        }

    }
    const updateRecord = async (item) => {
        console.log("item",item);
        setFromFields(item);
        setFileFields(item.image)
        setImageshow(true)

    }

    const openModal = async (item) => {
        setSubTopicData(item)
        setPostModal(true)

    }
    const deleteRecord = async (item) => {
        const Response = await deleteDevelopmentImages(item);
        // console.log("Delete resp",Response.data);
        if (Response.data?.id) {
            notifyTopFullWidth("Data deleted successfully");
            getAllTopic()
        }


    }
    const closemodal = async () => {
        setPostModal(false)
    }

    function handleChangeFile(files) {
        console.log(files);
        setFileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setFileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setImageshow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }


    return (
        <>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="row">
                <div className="form-group mb-3 col-md-3">
                    <label>Display Position</label>
                    <input component="input"
                        placeholder="display position"
                        name="position"
                        className="form-control"
                        value={position} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.position}</div>
                </div>
                {/* <div className="form-group mb-3 col-md-3">
                    <label>Topic Name</label>
                    <input component="input"
                        placeholder="Topic Name"
                        name="name"
                        className="form-control"
                        value={name} maxLength={50} onChange={handleChange} />
                    <div className="errorMsg">{errorFields.name}</div>
                </div> */}
                <div className="form-group mb-3 col-md-3">
                    <label>Status</label>
                    <select
                        className="form-control" name='status'
                        onChange={handleChange} value={status}>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>
                    <div className="errorMsg">{errorFields.status}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label
                    >
                         Image 
                    </label>
                    <div className="custom-file">
                        <FileBase64
                            multiple={true}
                            onDone={handleChangeFile} />
                    </div>
                    <div className="errorMsg">{errorFields.base64}</div>
                </div>

                <br />
                {imageshow && <> <div className="form-group mb-3 row">
                    <label
                        className="col-lg-4 col-form-label"
                        htmlFor="val-username"
                    >
                        Uploaded Image
                    </label>
                    <img src={filefields} alt="Red dot" />

                </div> </>}
                <div className="form-group mb-3 col-md-3">
                    <Button onClick={submitForm} className="me-2" variant="info">
                        Save Images
                    </Button>

                </div>


            </div>

            <Table responsive>
                <thead>
                    <tr>
                        <th className="width80">
                            <strong>Display Position</strong>
                        </th>
                        <th>
                            <strong>Image</strong>
                        </th>
                        <th>
                            <strong>Status </strong>
                        </th>

                    </tr>
                </thead>
                <tbody>
                    {topic?.map(item => (
                        <tr>
                            <td>
                                <strong>{item.position}</strong>
                            </td>
                            <td>
                                <img style={{ "height": "100px" }}
                                    src={item.image} alt="Red dot" />
                            </td>
                            <td>{item.status}</td>
                            <td>
                                <Button onClick={() => updateRecord(item)} className="me-2"
                                    variant="info">
                                    Update
                                </Button>

                                {/* {subadminbar && <Button onClick={() => deleteRecord(item)} className="me-2" variant="danger">
                                    Delete
                                </Button>} */}



                            </td>


                        </tr>
                    ))}

                </tbody>
            </Table>

            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">
                                {subTopicData.name}
                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <Suspense fallback={<div>Loading</div>}>
                                    {/* <SubTopics subtopicprops={subTopicData}/> */}
                                </Suspense>


                            </div>

                        </form>

                    </div>
                </div>
            </Modal>


        </>
    )
}

export default AddDevelopmentImages